/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkingHoursApiModel } from './workingHoursApiModel';
import { TimeIntervalApiModel } from './timeIntervalApiModel';


export interface CalendarApiModel { 
    id: number;
    workingHours: Array<WorkingHoursApiModel>;
    vacations: Array<TimeIntervalApiModel>;
    additionalHours: Array<TimeIntervalApiModel>;
    showAllFreeSlots: boolean;
}

